module.exports = __webpack_public_path__ + "static/media/bodie3.9b5ca6d1.png";